export default __webpack_public_path__ + "static/media/Shubham_resume.362e5463.pdf";